<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Transacción con tarjeta"
          directory=""
          :icon="'grid'"
        />
      </div>
    </div>

    <div class="col-md-12">
        <legend class="text-primary my-3">
          <h5>Datos de búsqueda</h5>
        </legend>
        <div class="row">
            <div class="col-md-4">
                <label for="inputs_from_id">
                    Desde:
                </label>
                <app-input id="inputs_to_id" type="date" v-model="date_start"
                    :required="true" />
            </div>
            <div class="col-md-4">
                <label for="inputs_to_id">
                    Hasta:
                </label>
                <app-input id="inputs_to_id" type="date" v-model="date_end"
                    :required="true" />
            </div>
            <div class="col-md-4">
                <label><span style="color: transparent;">a</span></label>
                <button type="button" class="btn btn-primary btn-lg btn-block" @click="getFilter()">
                <app-icon name="search" />
                Buscar
            </button>
            </div>
        </div>   
    </div>
    <div class="col-md-12">
        <legend class="text-primary my-4">
          <h5>Historial de transacciones</h5>
        </legend>
        <app-table :id="tableId" :options="options" @action="getListAction"/>
    </div>

    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="modal-confirm-id"
      @confirmed="refundTransaction"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea Reembolso?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { TableHelpers } from "./TableHelpers";
import { axiosPost } from "@/app/helpers/AxiosHelper";

export default {
extends: CoreLibrary,
  mixins: [FormMixin, TableHelpers],
  data() {
    return {
        tableId: "index-card-transaction-table",
        date_start: new Date(),
        date_end: new Date(),
        options: {
            url: `/treasury/card-transactions/getTransaction/${1}`,
            name: "",
            showHeader: true,
            columns: [],
            actions: [
              {
                title: this.$t("Reembolso"),
                icon: "rotate-ccw",
                type: "none",
              },
            ],
            showFilter: false,
            showSearch: false,
            paginationType: "pagination",
            responsive: true,
            rowLimit: 10,
            showAction: true,
            orderBy: "desc",
            actionType: "default",
        },
        rowData: {},
        confirmationModalActive: false,
        showRefund: false
    }
  },
  created() {
    this.options.columns = [
            ...this.tableColumns, this.actionObj
        ];
  },
  methods: {
    getFilter() {
        var tmp = {};
        if (!this.date_start || !this.date_end) {
            this.$toastr.e("Debe seleccionar un rango de fechas");
            return;
        }
        if (this.date_start > this.date_end) {
            this.$toastr.e("La segunda fecha debe ser mayor que la primera");
            return;
        }
        const d = this.date_start;
        tmp.date_start = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");

        const e = this.date_end;
        tmp.date_end = [e.getFullYear(), e.getMonth() + 1, e.getDate()].join("-");

        this.options = {
            url: `/treasury/card-transactions/getTransaction/${1}?date_start=${tmp.date_start}&date_end=${tmp.date_end}`,
            name: "",
            showHeader: true,
            columns: [],
            actions: [
              {
                title: this.$t("Reembolso"),
                icon: "rotate-ccw",
                type: "none",
              },
            ],
            showFilter: false,
            showSearch: false,
            paginationType: "pagination",
            responsive: true,
            rowLimit: 10,
            showAction: true,
            orderBy: "desc",
            actionType: "default",
        };
        this.options.columns = [
            ...this.tableColumns, this.actionObj
        ];

        setTimeout(() => this.$hub.$emit("reload-" + this.tableId), 500);
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      this.showRefund=true;
      
      if (actionObj.title == this.$t("Reembolso")) {
        if (this.rowData.status_detail == "3") {
          this.openRefundModal();
        } else {
          this.$toastr.e("No permite reembolso, transacción denegada");
          return;
        }
        
      }
    },

    openRefundModal() {
      this.confirmationModalActive = true;
    },
    cancelled() {
      this.confirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
    },

    refundTransaction() {
      let urlPay  = `/accreditations/paymentez/refund`;
      axiosPost(urlPay, {
          "transaction": {
            "id": this.rowData.transaction_reference
          }
        })
        .then((res) => {
          if (res.status === 200 && res.data.status == 'success') {
            this.$toastr.s("Reembolso completado.");
          } else if (res.status === 200 && res.data.status == 'failure') {
            this.$toastr.e("Ya fue Reembolsaldo");
          }
          else {
            this.$toastr.e("Error, comunicarse con el administrador");
          }
        })
        .catch(({ error }) => {
          console.error('Error en Nuvei:', error);
        })
        .finally(() => {
          this.getFilter();
          this.reSetData();

      });
    }
  }
}
</script>

<style>

</style>